import { Button } from 'antd';
import styled from 'styled-components';

export const AddButton = styled(Button)`
	height: 40px;
	width: 40px;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.colors.primary};
	border: ${({ theme }) => theme.colors.primary};

	svg {
		font-size: 1.4rem;
	}
`;
